<div>
    <h2>{{name}}</h2>
    <p>{{content}}</p>
    <ng-content></ng-content>
</div>